export const getIsPreview = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const isPreview = params.get("t");
  return Boolean(isPreview) || url.hostname === "preview.animaapp.com";
};
